(function () {
	function swiperInit() {
		subSliderInit(true);
		sliderInit(true);

		// With centeredSlides:true + slidesPerView:3, Swiper's snap grid maps
		// both slide 0 and slide 1 to translate=0, so initialization can land
		// at activeIndex=1. Reset both sliders synchronously so the user never
		// sees the stale position. The target is the main list's data-initial-slide
		// (the selected variant's image in a show_all gallery), or 0 when it is not set.
		var mainLists = document.querySelectorAll('.js-media-list');
		var subLists = document.querySelectorAll('.js-media-sublist');
		var initialFor = function (index) {
			var mainEl = mainLists[index];
			var n = mainEl ? parseInt(mainEl.dataset.initialSlide, 10) : 0;
			return n > 0 ? n : 0;
		};

		// A gallery with a start slide is already sliding there (sliderInit); resetting it here
		// would cut that animation short, so only galleries that start on slide 0 are reset.
		subLists.forEach(function(subEl, index) {
			if (!subEl.swiper || initialFor(index) > 0) return;
			var target = Math.min(initialFor(index), Math.max(0, subEl.swiper.slides.length - 1));
			if (subEl.swiper.params.loop && typeof subEl.swiper.slideToLoop === 'function') {
				subEl.swiper.slideToLoop(target, 0, false);
			} else {
				subEl.swiper.slideTo(target, 0, false);
			}
		});
		mainLists.forEach(function(mainEl, index) {
			if (mainEl.swiper && initialFor(index) === 0) {
				mainEl.swiper.slideTo(initialFor(index), 0, false);
				if (typeof mainEl.swiper.thumbs?.update === 'function') {
					mainEl.swiper.thumbs.update();
				}
			}
		});
	}

	document.addEventListener("shopify:section:load", function (e) {
		swiperInit();
	});

	//window.addEventListener("resize", function () {
	//	$(".product-section .js-media-list").each(function () {
	//		this.swiper.destroy();
	//	});
	//	$(".product-section .js-media-sublist").each(function () {
	//		this.swiper.destroy();
	//	});

	//	swiperInit();
	//});

	swiperInit();
})();
